// Pure helpers for the per-request conversation thread.
// The authoritative thread comes from GET /api/requests/:id; these helpers
// build an instant view from the already-loaded overview.comments feed.

export function commentsForRequest(comments = [], requestId) {
  return (comments || [])
    .filter((comment) => comment.requestId === requestId)
    .slice()
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
}

export function isOwnComment(comment, userId) {
  return Boolean(userId) && comment?.authorUserId === userId;
}
